import { FINANCE_DASHBOARD_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
    getIncomeExpenseLoading: false,
    getIncomeExpenseSuccess: false,
    getIncomeExpenseFailure: false,
    getIncomeExpenseError: null,
    getExpenseTypeWiseLoading: false,
    getExpenseTypeWiseSuccess: false,
    getExpenseTypeWiseFailure: false,
    getExpenseTypeWiseError: null,
    getProjectBudgetLeadLoading: false,
    getProjectBudgetLeadSuccess: false,
    getProjectBudgetLeadFailure: false,
    getProjectBudgetLeadError: null,
    getMonthlyExpenseLoading: false,
    getMonthlyExpenseSuccess: false,
    getMonthlyExpenseFailure: false,
    getMonthlyExpenseError: null,
    getYearlyIncomeExpenseLoading: false,
    getYearlyIncomeExpenseSuccess: false,
    getYearlyIncomeExpenseFailure: false,
    getYearlyIncomeExpenseError: null,
    incomeExpenseData: [],
    expenseTypeWiseData: [],
    projectBudgetLeadData: [],
    monthlyExpense: [],
    yearlyIncomeExpense: [],
}

export const financeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_REQUEST:
            return {
                ...state,
                getIncomeExpenseLoading: true,
                getIncomeExpenseSuccess: false,
                getIncomeExpenseFailure: false,
                getIncomeExpenseError: null
            }
        case FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_SUCCESS:
            return {
                ...state,
                getIncomeExpenseLoading: false,
                getIncomeExpenseSuccess: true,
                getIncomeExpenseFailure: false,
                getIncomeExpenseError: null,
                incomeExpenseData: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_FAILURE:
            return {
                ...state,
                getIncomeExpenseLoading: false,
                getIncomeExpenseSuccess: false,
                getIncomeExpenseFailure: true,
                getIncomeExpenseError: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_REQUEST:
            return {
                ...state,
                getExpenseTypeWiseLoading: true,
                getExpenseTypeWiseSuccess: false,
                getExpenseTypeWiseFailure: false,
                getExpenseTypeWiseError: null
            }
        case FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_SUCCESS:
            return {
                ...state,
                getExpenseTypeWiseLoading: false,
                getExpenseTypeWiseSuccess: true,
                getExpenseTypeWiseFailure: false,
                getExpenseTypeWiseError: null,
                expenseTypeWiseData: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_FAILURE:
            return {
                ...state,
                getExpenseTypeWiseLoading: false,
                getExpenseTypeWiseSuccess: false,
                getExpenseTypeWiseFailure: true,
                getExpenseTypeWiseError: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_REQUEST:
            return {
                ...state,
                getProjectBudgetLeadLoading: true,
                getProjectBudgetLeadSuccess: false,
                getProjectBudgetLeadFailure: false,
                getProjectBudgetLeadError: null
            }
        case FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_SUCCESS:
            return {
                ...state,
                getProjectBudgetLeadLoading: false,
                getProjectBudgetLeadSuccess: true,
                getProjectBudgetLeadFailure: false,
                getProjectBudgetLeadError: null,
                projectBudgetLeadData: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_FAILURE:
            return {
                ...state,
                getProjectBudgetLeadLoading: false,
                getProjectBudgetLeadSuccess: false,
                getProjectBudgetLeadFailure: true,
                getProjectBudgetLeadError: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_REQUEST:
            return {
                ...state,
                getMonthlyExpenseLoading: true,
                getMonthlyExpenseSuccess: false,
                getMonthlyExpenseFailure: false,
                getMonthlyExpenseError: null,
            }
        case FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_SUCCESS:
            return {
                ...state,
                getMonthlyExpenseLoading: false,
                getMonthlyExpenseSuccess: true,
                getMonthlyExpenseFailure: false,
                getMonthlyExpenseError: null,
                monthlyExpense: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_FAILURE:
            return {
                ...state,
                getMonthlyExpenseLoading: false,
                getMonthlyExpenseSuccess: false,
                getMonthlyExpenseFailure: true,
                getMonthlyExpenseError: action.payload,
            }
        case FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_REQUEST:
            return {
                ...state,
                getYearlyIncomeExpenseLoading: true,
                getYearlyIncomeExpenseSuccess: false,
                getYearlyIncomeExpenseFailure: false,
                getYearlyIncomeExpenseError: null,
            }
        case FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_SUCCESS:
            return {
                ...state,
                getYearlyIncomeExpenseLoading: false,
                getYearlyIncomeExpenseSuccess: true,
                getYearlyIncomeExpenseFailure: false,
                getYearlyIncomeExpenseError: null,
                yearlyIncomeExpense: action.payload
            }
        case FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_FAILURE:
            return {
                ...state,
                getYearlyIncomeExpenseLoading: false,
                getYearlyIncomeExpenseSuccess: false,
                getYearlyIncomeExpenseFailure: true,
                getYearlyIncomeExpenseError: action.payload,
            }
        default:
            return state;
    }
}